/**
 * Type guard function that checks if a value is an array.
 * Returns true if the value is an array, false otherwise.
 *
 * @param value - The value to check
 * @returns True if the value is an array, false otherwise
 */
export function IsArray<T>(value: T): value is T & unknown[] {
  return Array.isArray(value)
}
